export default __webpack_public_path__ + "static/media/vmg_client.f5b6e51b.png";